<template>
  <el-dialog
    title="点选验证码操作区域"
    v-model="dialogVisible"
    width="318px"
    @close="handleClose"
    :z-index="9999"  
  >
    <div class="captcha-container">
      <!-- 提示文字图片区域（仅展示） -->
      <div class="tip-area" v-if="tipImageUrl">
        <img :src="tipImageUrl" class="tip-img" />
      </div>
      <!-- 背景图点击区域 -->
      <div class="bg-area" @click="handleImageClick">
        <img :src="bgImageUrl" ref="captchaImg" />
        <div
          v-for="(dot, index) in clickDots"
          :key="index"
          class="dot"
          :style="{ left: dot.x + 'px', top: dot.y + 'px' }"
        >
          {{ index + 1 }}
        </div>
      </div>
    </div>

    <template #footer>
      <el-button @click="handleReset">重置</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { message } from 'heyui.ext';
import { Invoice } from "@/api/Invoice";
import { onMounted, onUnmounted } from 'vue';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  taskId: {
    type: String,
    default: ''
  },
  tipImageUrl: {       // 新增：提示文字图片URL
    type: String,
    default: ''
  },
  bgImageUrl: {        // 新增：背景图片URL
    type: String,
    default: ''
  }
});

const emit = defineEmits(['update:visible', 'success']);

const dialogVisible = computed({
  get: () => props.visible,
  set: (val) => emit('update:visible', val)
});

const captchaImg = ref(null);
const clickDots = ref([]);
// let captchaImgRect = null;

watch(() => props.visible, (val) => {
  if (val) {
    clickDots.value = [];
    // setTimeout(() => {
    //   if (captchaImg.value) {
    //     captchaImgRect = captchaImg.value.getBoundingClientRect();
    //   }
    // }, 300);
  }
});

const handleImageClick = (e) => {
  if (!captchaImg.value) return;
  // 每次点击都重新获取图片当前的实际位置和尺寸
  const rect = captchaImg.value.getBoundingClientRect();
  const x = parseInt(e.clientX - rect.left);
  const y = parseInt(e.clientY - rect.top);
  clickDots.value.push({ x, y });
};

const handleReset = () => {
  clickDots.value = [];
};

const handleSubmit = async () => {
  if (clickDots.value.length === 0) {
    message.warn('请点击图片中的文字');
    return;
  }
  try {
    await Invoice.submitRpa(props.taskId, clickDots.value);
    emit('success');
    emit('update:visible', false);
    clickDots.value = [];
    message.success('验证码提交成功');
  } catch (err) {
    const msg = err?.msg || '提交失败，请重试';
    message.error('提交失败：' + msg);
  }
};

const handleClose = () => {
  clickDots.value = [];
  emit('update:visible', false);
};

const handleResize = () => {
  if (dialogVisible.value && clickDots.value.length > 0) {
    clickDots.value = [];
    message.warn('窗口大小已改变，请点击重置，重选验证码区域');
  }
};

onMounted(() => {
  window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});
</script>

<style scoped>

.captcha-container {
  text-align: center;
}
.tip-area {
  margin-bottom: 20px;
  text-align: center;
}
.tip-img {
  max-width: 100%;
  border: 1px solid #ddd;
  background: #f5f5f5;
}
.bg-area {
  position: relative;
  cursor: pointer;
  display: inline-block;
}
.dot {
  position: absolute;
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 50%;
  background: rgba(255, 0, 0, 0.7);
  color: white;
  font-size: 12px;
  text-align: center;
  transform: translate(-50%, -50%);
}
img {
  width: auto !important;
  height: auto !important;
  max-width: 100% !important;
  object-fit: unset !important;
}

</style>